import { createUserProfileApi } from "api/services/user-profile";
import { StrainQuiz } from "custom-types/StrainQuiz";
import logError from "utils/logError";

/**
 *  GET strain preference quiz
 */
const getStrainQuiz = async (
  domainCountryCode: string,
): Promise<StrainQuiz> => {
  try {
    const userProfileServiceApi = createUserProfileApi(domainCountryCode);
    const { data } = await userProfileServiceApi.get(
      "/v1/strain-preference-quiz",
    );

    if (!data) {
      return [];
    }

    return data.data;
  } catch (e) {
    logError(e.message, {
      functionName: "getStrainQuiz",
      service: "userprofile",
      statusCode: e.statusCode,
    });
    return [];
  }
};

export default getStrainQuiz;
